import styled from "styled-components";

export default styled.div`
  .chat-list {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .chat-list-fallback {
    }
  }

  @media screen and (max-width: 768px) {
    .chat-list {
      gap: 0.3rem;

      .chat-list-fallback {
      }
    }
  }
`;
